var REACT_ELEMENT_TYPE;function _jsx(type, props, key, children) {REACT_ELEMENT_TYPE || (REACT_ELEMENT_TYPE = "function" == typeof Symbol && Symbol.for && Symbol.for("react.element") || 60103);var defaultProps = type && type.defaultProps,childrenLength = arguments.length - 3;if (props || 0 === childrenLength || (props = { children: void 0 }), 1 === childrenLength) props.children = children;else if (childrenLength > 1) {for (var childArray = new Array(childrenLength), i = 0; i < childrenLength; i++) childArray[i] = arguments[i + 3];props.children = childArray;}if (props && defaultProps) for (var propName in defaultProps) void 0 === props[propName] && (props[propName] = defaultProps[propName]);else props || (props = defaultProps || {});return { $$typeof: REACT_ELEMENT_TYPE, type: type, key: void 0 === key ? null : "" + key, ref: null, props: props, _owner: null };} /* eslint-disable react/no-multi-comp */
import React from 'react';
import { XMarkIcon } from '@heroicons/react/20/solid';







const Modal = ({ children, size }) => {
  const sizes = {
    sm: 'max-w-sm',
    md: 'max-w-md',
    lg: 'max-w-lg',
    xl: 'max-w-xl',
    xxl: 'max-w-2xl',
    xxxl: 'max-w-3xl'
  };

  return /*#__PURE__*/(
    _jsx("div", {
      "aria-hidden": "false",
      className: "flex overflow-x-hidden fixed inset-0 top-0 left-0 z-50 justify-center items-center bg-gray-900 bg-opacity-50",
      "data-testid": "modal",
      role: "dialog",
      "aria-label": "Modal" }, void 0, /*#__PURE__*/

    _jsx("div", { className: `max-h-screen ${sizes[size]}` }, void 0, /*#__PURE__*/
    _jsx("div", { className: "bg-white rounded-lg shadow" }, void 0, children)
    )
    ));

};






Modal.Header = ({ children, className }) => /*#__PURE__*/
_jsx("div", {
  className: `${className} flex items-start justify-between rounded-t ${
  children ? 'p-5 border-b' : 'p-2'
  }` }, void 0,

children
);


Modal.Body = ({ children, className }) => /*#__PURE__*/
_jsx("div", {
  className: `overflow-y-auto p-6 h-full md:max-h-[70vh] ${className}`,
  "data-testid": "modal-body" }, void 0,

children
);


Modal.Footer = ({ children }) => /*#__PURE__*/
_jsx("div", { className: "flex justify-center p-6 space-x-2 rounded-b border-t border-gray-200" }, void 0,
children
);


Modal.CloseButton = ({
  className,
  onClick
}) => /*#__PURE__*/
_jsx("button", {
  onClick: onClick,
  "aria-label": "Close modal",
  className: `${className} ml-auto inline-flex items-center rounded-lg bg-transparent 
    p-1.5 text-sm text-gray-400 hover:bg-gray-200 hover:text-gray-900 `,
  type: "button" }, void 0, /*#__PURE__*/

_jsx(XMarkIcon, { className: "w-4" })
);



export { Modal };